// extracted by mini-css-extract-plugin
export default {"contents-container":"dObJjUmuQXi3kXTflW_8","info-section":"OL3KIJN7h4cj1AVK4yGV"};